export const mergeFilters = (filterA, filterB) => {
  const obj = { ...filterA, ...filterB }
  Object.keys(obj).forEach((key) => {
    const set = new Set()
    let value
    if (filterA[key]) {
      if (Array.isArray(filterA[key])) {
        filterA[key].forEach((filter) => {
          set.add(filter)
        })
      } else {
        value = filterA[key]
      }
    }
    if (filterB[key]) {
      if (Array.isArray(filterB[key])) {
        filterB[key].forEach((filter) => {
          set.add(filter)
        })
      } else {
        value = filterB[key]
      }
    }
    obj[key] = Array.isArray(filterA[key]) || Array.isArray(filterB[key]) ? Array.from(set) : value
    if (Array.isArray(obj[key]) && obj[key].length === 0) {
      delete obj[key]
    }
  })
  return obj
}

export const diffFilters = (selectedFilter, allFilters) => {
  const obj = { ...selectedFilter, ...allFilters }
  const returnedObj = {}
  Object.keys(obj).forEach((key) => {
    const set = new Set()
    if (!selectedFilter[key] && allFilters[key]) {
      returnedObj[key] = allFilters[key]
    }
    if (selectedFilter[key] && allFilters[key]) {
      const diff = allFilters[key].filter((filterName) => !selectedFilter[key].includes(filterName))
      diff.forEach((filterName) => {
        set.add(filterName)
      })
      returnedObj[key] = Array.from(set)
    }
  })
  return returnedObj
}
